module.exports = __webpack_public_path__ + "media/warranty-claim/photos-close-up4-b1c668ce.png";